import articlesRelatedToEntity from './articles-related-to-entity'

const createQuery = () => {
  const query = `query AllArticles($url: String!, $type: String!, $contentType: String, $page: Int = 1) {
    ${articlesRelatedToEntity()}
  }`
  return query
}

export default createQuery
